// errorBoundary.js
import { PostHogErrorBoundary } from "posthog-js/react";

export function withErrorBoundary(Component, fallback) {
  const WrappedComponent = (props) => (
    <PostHogErrorBoundary fallback={fallback}>
      <Component {...props} />
    </PostHogErrorBoundary>
  );
  WrappedComponent.displayName = `WithErrorBoundary(${Component.name})`;
  return WrappedComponent;
}
